// @ts-ignore
import { InboxOutlined, UploadOutlined } from '@ant-design/icons';
import {
  Button,
  Col,
  Collapse,
  DatePicker,
  Form,
  Image,
  Input,
  InputNumber,
  message,
  PageHeader,
  Row,
  Select,
  Spin,
  Switch,
  Upload,
} from 'antd';
import { Content } from 'antd/es/layout/layout';
import { ContentState, convertFromHTML, EditorState } from 'draft-js';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { Editor } from 'react-draft-wysiwyg';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useParams } from 'react-router-dom';

// import { fallBackImage } from '../../../assets/images/fallbackImage';
import { SelectCollectionAttribute } from '../../collectionAttributes/components/SelectCollectionAttribute';
import {
  addCollectionEntity,
  addCollectionToUser,
  getCollectionEntityById,
  getCollectionEntityLoading,
  getWatchProviders,
  setCollectionEntityLoading,
  updateCollectionEntity,
} from '../collectionEntitySlice';
import CastAndCrewTable from '../components/CastAndCrewTable/index';
import WatchProvidersTableComponent from '../components/WatchProviders/WatchProvidersTable';
import { CollectionEntitySuccessComponent } from './CollectionEntitySuccessComponent';

type Props = {};

interface WatchProvider {
  name: string;
  logo: string;
}
interface CastAndCrewDTO {
  key: React.Key;
  name: string;
  type: string;
  character: string;
  image: { fileName: string };
  imageUrl?: string;
}
interface formData {
  watchProviderBuy: WatchProvider[];
  watchProviderRent: WatchProvider[];
  watchProviderFlatRate: WatchProvider[];
  watchProviders: WatchProvider[];
  directors: any;
  castAndCrews: CastAndCrewDTO[];
  authors: any;
  placeTypes: any;
  id: number;
  coverImage: string;
  images: [];
  county: any;
  country: any;
  genres: any;
  isPermanentlyClosed?: boolean;
  collectionType: any;
}
export const CollectionEntityEditPage: React.FC<Props> = (props: any) => {
  const [form] = Form.useForm();
  const [editorState, setEditorState] = useState(EditorState.createEmpty());
  const [formData, setFormData] = useState<formData>(undefined);
  const history = useHistory();
  const dispatch = useDispatch();
  const isLoading = useSelector(getCollectionEntityLoading);
  const [pageState, setPageState] = useState('edit');
  const { collectionEntityId } = useParams();
  const [removedImages, setRemovedImages] = useState([]);
  const [castAndCrews, setCastAndCrews] = useState([]);
  const imageCdnUrl = 'https://dutdn00ph75f2.cloudfront.net/images/';
  const { Panel } = Collapse;
  const [watchProviders, setWatchProviders] = useState([]);
  const [entitiesWatchProvidersToFlat, setEntitiesWatchProvidersToFlat] =
    useState([]);
  const [entitiesWatchProvidersToRent, setEntitiesWatchProvidersToRent] =
    useState([]);
  const [entitiesWatchProvidersToBuy, setEntitiesWatchProvidersToBuy] =
    useState([]);
  const TEST_ACCOUNT_ID = 1798;
  const fetchWatchProviders = async () => {
    // @ts-ignore
    const _response = (await dispatch(getWatchProviders())).payload;
    // _response.push({name:`Add Empty - ${Date.now()}`, key:Date.now(), logo: "https://hoopt.s3.eu-west-1.amazonaws.com/static/black_logo.jpg"});
    setWatchProviders(_response);
  };

  useEffect(() => {
    fetchWatchProviders();
  }, []);

  useEffect(() => {
    if (collectionEntityId > 0) {
      getDetails(collectionEntityId);
    } else {
      console.log('resetting form');
      form.resetFields();
      setEditorState(EditorState.createEmpty());
      setFormData(undefined);

      setCastAndCrews([]);
      setEntitiesWatchProvidersToBuy([]);
      setEntitiesWatchProvidersToRent([]);
      setEntitiesWatchProvidersToFlat([]);
    }
  }, [collectionEntityId]);

  const onCastAndCrewSubmit = (castAndCrewDatas) => {
    const _castAndCrewManipulated = castAndCrewDatas.map((i) => {
      return {
        character: i.character,
        name: i.name,
        type: i.type,
        image: { fileName: i.imageUrl, fileNameOriginal: i.imageUrl },
      };
    });
    setCastAndCrews(_castAndCrewManipulated);
  };

  const watchProvidersSubmit = (watchProviders: WatchProvider[], type) => {
    console.log(type, watchProviders);
    const _watchProvidersManipulated = watchProviders.map((i) => {
      return {
        name: i.name,
        logo: i.logo,
      };
    });

    switch (type) {
    case 'flat':
      setEntitiesWatchProvidersToFlat(_watchProvidersManipulated);
      break;

    case 'rent':
      setEntitiesWatchProvidersToRent(_watchProvidersManipulated);
      break;

    case 'buy':
      setEntitiesWatchProvidersToBuy(_watchProvidersManipulated);

      break;
    }
  };

  const getDetails = async (collectionEntityId) => {
    if ((collectionEntityId ?? 0) === 0) return;

    try {
      await dispatch(setCollectionEntityLoading(true));
      const response = await dispatch(
        getCollectionEntityById(collectionEntityId)
      );
      setEditorState(
        EditorState.createWithContent(
          ContentState.createFromBlockArray(
            convertFromHTML(response.payload?.description ?? '')
          )
        )
      );
      if (response?.payload?.releaseDate) {
        response.payload.releaseDateTicks = moment(
          response.payload.releaseDate
        );
      }
      console.log(114, response.payload);
      form.setFieldsValue(response.payload);
      setFormData(response.payload);
      setCastAndCrews(response.payload.castAndCrews);
      setEntitiesWatchProvidersToBuy(
        response.payload.watchProviderBuy?.map((i, j) => {
          i.key = j;
          return { ...i };
        })
      );
      setEntitiesWatchProvidersToRent(
        response.payload.watchProviderRent?.map((i, j) => {
          i.key = j;
          return { ...i };
        })
      );
      setEntitiesWatchProvidersToFlat(
        response.payload.watchProviderFlatRate?.map((i, j) => {
          i.key = j;
          return { ...i };
        })
      );
      await dispatch(setCollectionEntityLoading(false));
    } catch (e) {
      message.error(e.message);
      await dispatch(setCollectionEntityLoading(false));
    }
  };

  const onFinish = async (values: any) => {
    values.castAndCrews = castAndCrews;
    values.description = editorState.getCurrentContent().getPlainText();
    values.genres =
      values.genres?.map((p) => (typeof p === 'string' ? p : p.value)) ?? null;
    values.directors =
      values.directors?.map((p) => (typeof p === 'string' ? p : p.value)) ??
      null;
    values.placeTypes =
      values.placeTypes?.map((p) => (typeof p === 'string' ? p : p.value)) ??
      null;
    values.authors =
      values.authors?.map((p) => (typeof p === 'string' ? p : p.value)) ?? null;
    values.country = values.country?.value || values?.country;
    values.city = values.city?.value || values?.city;
    values.county = values.county?.value || values?.county;

    console.log(193, entitiesWatchProvidersToBuy);

    values.entitiesWatchProviders = {
      flat: entitiesWatchProvidersToFlat,
      rent: entitiesWatchProvidersToRent,
      buy: entitiesWatchProvidersToBuy,
    };

    values.removedImages = removedImages;

    if (values.releaseDateTicks) {
      values.releaseDateTicks = new Date(values.releaseDateTicks).getTime();
    }

    console.log(values);
    try {
      await dispatch(setCollectionEntityLoading(true));
      const newCollectionEntity =
        values.id > 0
          ? await dispatch(updateCollectionEntity(values))
          : await dispatch(addCollectionEntity(values));
      await dispatch(setCollectionEntityLoading(false));
      if ((values.id ?? 0) > 0 || (newCollectionEntity?.payload?.id ?? 0) > 0) {
        setPageState('result');
        values.id = newCollectionEntity?.payload?.id;
        setFormData(values);

        message.success('Updated the record');

        // add to bigacc test account's collection
        await dispatch(
          addCollectionToUser({
            collectionEntityId: newCollectionEntity?.payload?.id,
            userId: TEST_ACCOUNT_ID,
          })
        );

      } else {
        message.error(
          newCollectionEntity?.error?.message ?? 'Failed to add record'
        );
      }
    } catch (e) {
      dispatch(setCollectionEntityLoading(false));
      message.error(e.message);
    } finally {
      // eslint-disable-next-line
      // @ts-ignore
      window?.scrollTo(0, 0);
    }
  };

  const onFinishFailed = (errorInfo: any) => {
    errorInfo.errorFields.map(i => i.errors).map(d =>  message.error((d[0])));
    console.log('Failed:', errorInfo.errorFields);
  };

  const normFile = (e: any) => {
    console.log('Upload event:', e);
    if (Array.isArray(e)) {
      return e;
    }
    return e && e.fileList;
  };

  const onImageSelected = (checked, image) => {
    const index = removedImages.indexOf(image);
    if (index > -1 && !checked) {
      removedImages.splice(index, 1);
    } else if (index === -1) {
      removedImages.push(image);
    }

    setRemovedImages(removedImages);
  };

  return (
    <div>
      {pageState === 'result' ? (
        <CollectionEntitySuccessComponent
          entityId={collectionEntityId > 0 ? collectionEntityId : formData.id}
          collectionEntity={formData}
        />
      ) : (
        <div>
          <PageHeader
            className="site-page-header"
            onBack={() => history.goBack()}
            title="Collection Entity"
          />
          <Content style={{ margin: '0px 16px 0', overflow: 'initial' }}>
            <div
              className="site-layout-background"
              style={{ padding: 24, textAlign: 'center' }}
            >
              <Spin spinning={isLoading}>
                <Row>
                  <Col span={20}>
                    <Form
                      name="collectionEntity"
                      labelCol={{ span: 4 }}
                      wrapperCol={{ span: 16 }}
                      form={form}
                      initialValues={collectionEntityId > 0 ? formData : {}}
                      onFinish={onFinish}
                      onFinishFailed={onFinishFailed}
                      autoComplete="off"
                    >
                      <Form.Item label="id" name="id" hidden>
                        <Input />
                      </Form.Item>
                      <Form.Item
                        label="Title"
                        name="title"
                        rules={[
                          {
                            required: true,
                            message: 'Please input entity title',
                          },
                        ]}
                      >
                        <Input />
                      </Form.Item>

                      <Form.Item
                        label="Sub Title"
                        name="subTitle"
                        tooltip="This field is auto-generated"
                      >
                        <Input disabled />
                      </Form.Item>
                      <Form.Item
                        required
                        label={
                          form.getFieldValue('collectionType') === 'Movie'
                            ? 'Collection Type / External Type'
                            : 'Collection Type'
                        }
                        style={{ marginBottom: 0 }}
                      >
                        <Form.Item
                          name="collectionType"
                          style={{
                            display: 'inline-block',
                            width: 'calc(50% - 12px)',
                          }}
                          rules={[
                            {
                              required: true,
                              message: 'Please input entity collection type',
                            },
                          ]}
                        >
                          <Select
                            onChange={(value) => {
                              form.setFieldsValue({
                                collectionType: value,
                              });
                              // @ts-ignore
                              setFormData({
                                ...formData,
                                collectionType: value,
                              });
                            }}
                          >
                            <Select.Option value="Place">Place</Select.Option>
                            <Select.Option value="Movie">Movie</Select.Option>
                            <Select.Option value="Book">Book</Select.Option>
                          </Select>
                        </Form.Item>
                        {form.getFieldValue('collectionType') === 'Movie' && (
                          <React.Fragment>
                            <span
                              style={{
                                display: 'inline-block',
                                width: '24px',
                                lineHeight: '32px',
                                textAlign: 'center',
                              }}
                            >
                              -
                            </span>
                            <Form.Item
                              name="externalGroupKey"
                              style={{
                                display: 'inline-block',
                                width: 'calc(50% - 12px)',
                              }}
                              rules={[
                                {
                                  required: true,
                                  message: 'Please fill this field',
                                },
                              ]}
                            >
                              <Select>
                                <Select.Option value="Movie">
                                  Movie
                                </Select.Option>
                                <Select.Option value="TVShow">
                                  TV Show
                                </Select.Option>
                              </Select>
                            </Form.Item>
                          </React.Fragment>
                        )}
                      </Form.Item>
                      <Form.Item
                        name="coverImage"
                        label="Cover Image"
                        getValueFromEvent={normFile}
                        initialValue={formData?.coverImage ?? ''}
                        rules={
                          (formData?.id ?? 0) === 0
                            ? [
                              {
                                required: true,
                                message: 'Please select a cover image',
                              },
                            ]
                            : undefined
                        }
                      >
                        <Upload name="coverImage" listType="picture">
                          <Button icon={<UploadOutlined />}>
                            Click to upload
                          </Button>
                        </Upload>
                      </Form.Item>
                      {formData?.coverImage?.startsWith?.('http') && (
                        <Form.Item label="Current Cover Image">
                          <Image
                            height={150}
                            src={formData.coverImage + '?width=200'}
                            preview={{ src: formData.coverImage }}
                          />
                        </Form.Item>
                      )}
                      {formData?.coverImage?.startsWith?.('http') && (
                        <Form.Item
                          label="Delete current cover image"
                          name="removeCoverImage"
                        >
                          <Switch
                            onChange={(checked) =>
                              form.setFieldsValue({ removeCoverImage: checked })
                            }
                            checkedChildren="YES"
                            unCheckedChildren="NO"
                          />
                        </Form.Item>
                      )}
                      <Form.Item label="Description" name="description">
                        <Editor
                          onEditorStateChange={(state) => setEditorState(state)}
                          editorState={editorState}
                          toolbar={{
                            options: [
                              'inline',
                              'list',
                              'textAlign',
                              'colorPicker',
                              'link',
                              'emoji',
                              'remove',
                              'history',
                            ],
                          }}
                          toolbarClassName="rdw-storybook-toolbar"
                          wrapperClassName="description-editor-wrapper"
                        />
                      </Form.Item>

                      {formData &&
                        form.getFieldValue('collectionType') !== 'Book' && (
                        <Form.Item label="Images">
                          <Form.Item
                            name="images"
                            getValueFromEvent={normFile}
                            noStyle
                          >
                            <Upload.Dragger
                              multiple={true}
                              name="images"
                              disabled={collectionEntityId == 0}
                            >
                              <p className="ant-upload-drag-icon">
                                <InboxOutlined />
                              </p>
                              <p className="ant-upload-text">
                                {collectionEntityId == 0
                                  ? 'To add images, first you need to add entity. Images are being added when editing an entity'
                                  : 'Click or drag file to this area to upload'}
                              </p>
                              <p className="ant-upload-hint">
                                  Support for a single or bulk upload.
                              </p>
                            </Upload.Dragger>
                          </Form.Item>
                        </Form.Item>
                      )}
                      {formData &&
                        formData?.images?.length &&
                        form.getFieldValue('collectionType') !== 'Book' && (
                        <Form.Item
                          label="Current Images"
                          tooltip={
                            formData.images.every((i: any) => !i.url) &&
                              'No image returned by Api'
                          }
                        >
                          {formData?.images?.map(
                            (image: any, index: number) => (
                              <div
                                key={index}
                                title={!image.url ? 'No image provided' : ''}
                                className="images-scroll-item"
                              >
                                <Row>
                                  <Image
                                    height={70}
                                    src={
                                      image.url &&
                                        (image.url?.includes(imageCdnUrl)
                                          ? image.url
                                          : imageCdnUrl +
                                            image?.url?.split('/').pop()?.replace('?','') +
                                             '?width=200')
                                    }
                                    alt={
                                      image.url &&
                                        (image.url?.includes(imageCdnUrl)
                                          ? image.url
                                          : imageCdnUrl +
                                            image?.url?.split('/').pop())
                                    }
                                    preview={{
                                      src:
                                          image.url &&
                                          (image.url?.includes(imageCdnUrl)
                                            ? image.url
                                            : imageCdnUrl +
                                              image?.url?.split('/').pop()),
                                    }}
                                  />
                                </Row>
                                <Row>
                                  <Switch
                                    style={{ color: 'red' }}
                                    size={'small'}
                                    onChange={(checked) =>
                                      onImageSelected(checked, image)
                                    }
                                    checkedChildren="Will Delete"
                                    unCheckedChildren="Delete"
                                  />
                                </Row>
                              </div>
                            )
                          )}
                        </Form.Item>
                      )}

                      {form.getFieldValue('collectionType') === 'Place' && (
                        <Form.Item
                          label="Place Type"
                          name="placeTypes"
                          rules={[
                            {
                              required: true,
                              message: 'Please select a place type',
                            },
                          ]}
                        >
                          <SelectCollectionAttribute
                            labelInValue
                            mode="tags"
                            showSearch
                            collectionType="Place"
                            collectionAttributeType="PlaceTypes"
                            value={formData?.placeTypes}
                            filterOption={false}
                          />
                        </Form.Item>
                      )}

                      {form.getFieldValue('collectionType') === 'Place' && (
                        <Form.Item
                          required
                          label="Country / Country Code"
                          style={{ marginBottom: 0 }}
                        >
                          <Form.Item
                            style={{
                              display: 'inline-block',
                              width: 'calc(50% - 12px)',
                            }}
                            name="country"
                            rules={[
                              {
                                required: true,
                                message: 'Please select a country',
                              },
                            ]}
                          >
                            <SelectCollectionAttribute
                              labelInValue
                              showSearch
                              collectionType="Place"
                              collectionAttributeType="Country"
                              value={formData?.country}
                              debounceTimeout={100}
                              onChange={(value) =>
                                form.setFieldsValue({
                                  country: value,
                                })
                              }
                              filterOption={false}
                            />
                          </Form.Item>
                          <span
                            style={{
                              display: 'inline-block',
                              width: '24px',
                              lineHeight: '32px',
                              textAlign: 'center',
                            }}
                          >
                            -
                          </span>
                          <Form.Item
                            style={{
                              display: 'inline-block',
                              width: 'calc(50% - 12px)',
                            }}
                            name="countryCode"
                            rules={[
                              {
                                required: true,
                                message: 'Please select a country',
                              },
                            ]}
                          >
                            <Input placeholder="US, TR etc." />
                          </Form.Item>
                        </Form.Item>
                      )}

                      {form.getFieldValue('collectionType') === 'Place' && (
                        <Form.Item
                          label="City"
                          name="city"
                          rules={[
                            { required: true, message: 'Please select a city' },
                          ]}
                        >
                          <SelectCollectionAttribute
                            labelInValue
                            showSearch
                            collectionType="Place"
                            collectionAttributeType="City"
                            filterOption={false}
                          />
                        </Form.Item>
                      )}

                      {form.getFieldValue('collectionType') === 'Place' && (
                        <Form.Item label="County" name="county">
                          <SelectCollectionAttribute
                            labelInValue
                            showSearch
                            collectionType="Place"
                            collectionAttributeType="County"
                            value={
                              formData.id
                                ? formData.county
                                : formData.county?.value
                            }
                            filterOption={false}
                          />
                        </Form.Item>
                      )}

                      {form.getFieldValue('collectionType') === 'Place' && (
                        <Form.Item
                          label="Address"
                          name="address"
                          rules={[
                            { required: true, message: 'Please put a address' },
                          ]}
                        >
                          <Input />
                        </Form.Item>
                      )}

                      {form.getFieldValue('collectionType') === 'Place' && (
                        <Form.Item
                          label="Permanently Closed"
                          name="isPermanentlyClosed"
                        >
                          <Switch
                            onChange={(checked) => {
                              form.setFieldsValue({
                                isPermanentlyClosed: checked,
                              });
                              // @ts-ignore
                              setFormData({
                                ...formData,
                                isPermanentlyClosed: checked,
                              });
                            }}
                            checked={formData.isPermanentlyClosed}
                          />
                        </Form.Item>
                      )}

                      {form.getFieldValue('collectionType') === 'Place' && (
                        <Form.Item label="Phone Number" name="phoneNumber">
                          <Input />
                        </Form.Item>
                      )}

                      {form.getFieldValue('collectionType') === 'Place' && (
                        <Form.Item label="Web Site" name="webSite">
                          <Input />
                        </Form.Item>
                      )}

                      {form.getFieldValue('collectionType') === 'Place' && (
                        <Form.Item label="Location" required>
                          <Form.Item
                            name="latitude"
                            style={{
                              display: 'inline-block',
                              width: 'calc(50% - 12px)',
                            }}
                            rules={[
                              {
                                required: true,
                                message: 'Please put a latitude',
                              },
                            ]}
                          >
                            <InputNumber
                              style={{ width: '100%' }}
                              decimalSeparator={','}
                            />
                          </Form.Item>
                          <span
                            style={{
                              display: 'inline-block',
                              width: '24px',
                              lineHeight: '32px',
                              textAlign: 'center',
                            }}
                          >
                            -
                          </span>
                          <Form.Item
                            name="longitude"
                            style={{
                              display: 'inline-block',
                              width: 'calc(50% - 12px)',
                            }}
                            rules={[
                              {
                                required: true,
                                message: 'Please put a longitude',
                              },
                            ]}
                          >
                            <InputNumber
                              style={{ width: '100%' }}
                              decimalSeparator={','}
                            />
                          </Form.Item>
                        </Form.Item>
                      )}

                      {form.getFieldValue('collectionType') === 'Movie' && (
                        <Form.Item
                          label="Genre"
                          name="genres"
                          rules={[
                            {
                              required: true,
                              message: 'Please select a genre',
                            },
                          ]}
                        >
                          <SelectCollectionAttribute
                            labelInValue
                            mode="tags"
                            showSearch
                            collectionType="Movie"
                            collectionAttributeType="Genre"
                            value={formData?.genres}
                            filterOption={false}
                          />
                        </Form.Item>
                      )}

                      {form.getFieldValue('collectionType') === 'Movie' && (
                        <Form.Item
                          label="Directors"
                          name="directors"
                          rules={[
                            {
                              required: true,
                              message: 'Please select a director',
                            },
                          ]}
                        >
                          <SelectCollectionAttribute
                            labelInValue
                            mode="tags"
                            showSearch
                            collectionType="Movie"
                            collectionAttributeType="Director"
                            value={formData.directors}
                            filterOption={false}
                          />
                        </Form.Item>
                      )}

                      {form.getFieldValue('collectionType') === 'Movie' && (
                        <Form.Item
                          label="Release Date"
                          name="releaseDateTicks"
                          initialValue={moment(
                            form.getFieldValue('releaseDateTicks')
                          )}
                          rules={[
                            {
                              required: true,
                              message: 'Please input release date',
                            },
                          ]}
                        >
                          <DatePicker picker="year" />
                        </Form.Item>
                      )}

                      {form.getFieldValue('collectionType') === 'Movie' && (
                        <Form.Item label="Cast and Crew" name="castAndCrew">
                          <Collapse
                            defaultActiveKey={
                              formData.castAndCrews?.length > 5
                                ? ''
                                : 'castAndCrew'
                            }
                            style={{ overflow: 'scroll' }}
                          >
                            <Panel header="Cast And Crew" key={'castAndCrew'}>
                              <CastAndCrewTable
                                onCastAndCrewSubmit={onCastAndCrewSubmit}
                                castAndCrewDatasRaw={formData.castAndCrews?.map(
                                  (i, j) => {
                                    i.key = j;
                                    i.imageUrl = i.image?.fileName;
                                    return { ...i };
                                  }
                                )}
                              />
                            </Panel>
                          </Collapse>
                        </Form.Item>
                      )}

                      {form.getFieldValue('collectionType') === 'Movie' && (
                        <Form.Item
                          label="Watch Providers"
                          name="watchProviders"
                        >
                          <Collapse
                            defaultActiveKey={
                              formData.watchProviders?.length
                                ? ''
                                : 'watchProvidersFlatRate'
                            }
                            style={{ overflow: 'scroll' }}
                          >
                            <Panel
                              header="Watch Providers Flat Rate"
                              key={'watchProvidersFlatRate'}
                            >
                              {watchProviders?.length && (
                                <>
                                  <WatchProvidersTableComponent
                                    currentWatchProviders={watchProviders}
                                    watchProvidersRaw={
                                      formData.watchProviderFlatRate
                                    }
                                    onWatchProvidersSubmit={(data) =>
                                      watchProvidersSubmit(data, 'flat')
                                    }
                                  />
                                </>
                              )}
                            </Panel>

                            <Panel
                              header="Watch Providers Buy"
                              key={'watchProvidersBuy'}
                            >
                              {watchProviders?.length && (
                                <>
                                  <WatchProvidersTableComponent
                                    currentWatchProviders={watchProviders}
                                    watchProvidersRaw={
                                      formData.watchProviderBuy
                                    }
                                    onWatchProvidersSubmit={(data) =>
                                      watchProvidersSubmit(data, 'buy')
                                    }
                                  />
                                </>
                              )}
                            </Panel>

                            <Panel
                              header="Watch Providers Rent"
                              key={'watchProvidersRent'}
                            >
                              {watchProviders?.length && (
                                <>
                                  <WatchProvidersTableComponent
                                    currentWatchProviders={watchProviders}
                                    watchProvidersRaw={
                                      formData.watchProviderRent
                                    }
                                    onWatchProvidersSubmit={(data) =>
                                      watchProvidersSubmit(data, 'rent')
                                    }
                                  />
                                </>
                              )}
                            </Panel>
                          </Collapse>
                        </Form.Item>
                      )}

                      {form.getFieldValue('collectionType') === 'Movie' && (
                        <Form.Item label="Runtime" name="runtime">
                          <InputNumber max={999} />
                        </Form.Item>
                      )}

                      {form.getFieldValue('collectionType') === 'Movie' && (
                        <Form.Item label="YouTube Id" name="youtubeId">
                          <Input />
                        </Form.Item>
                      )}

                      {form.getFieldValue('collectionType') === 'Movie' && (
                        <Form.Item label="Tagline" name="tagline">
                          <Input />
                        </Form.Item>
                      )}

                      {form.getFieldValue('collectionType') === 'Book' && (
                        <Form.Item
                          label="Genre"
                          name="genres"
                          rules={[
                            {
                              required: true,
                              message: 'Please select a genre',
                            },
                          ]}
                        >
                          <SelectCollectionAttribute
                            labelInValue
                            mode="tags"
                            showSearch
                            collectionType="Book"
                            collectionAttributeType="Genre"
                            value={formData?.genres}
                            filterOption={false}
                          />
                        </Form.Item>
                      )}

                      {form.getFieldValue('collectionType') === 'Book' && (
                        <Form.Item
                          label="Authors"
                          name="authors"
                          rules={[
                            {
                              required: true,
                              message: 'Please select a author',
                            },
                          ]}
                        >
                          <SelectCollectionAttribute
                            labelInValue
                            mode="tags"
                            showSearch
                            collectionType="Book"
                            collectionAttributeType="Author"
                            value={formData.authors}
                            filterOption={false}
                          />
                        </Form.Item>
                      )}

                      {form.getFieldValue('collectionType') === 'Book' && (
                        <Form.Item
                          label="Language Code"
                          name="language"
                          rules={[
                            {
                              required: true,
                              message:
                                'Please put a language code. (en, tr etc.)',
                            },
                          ]}
                        >
                          <Input placeholder="en, tr, it etc." />
                        </Form.Item>
                      )}

                      {form.getFieldValue('collectionType') === 'Book' && (
                        <Form.Item label="Page Count" name="pageCount">
                          <InputNumber />
                        </Form.Item>
                      )}

                      {form.getFieldValue('collectionType') === 'Book' && (
                        <Form.Item
                          label="Publish Year"
                          name="publishYear"
                          rules={[
                            {
                              required: true,
                              message: 'Publish year must not be empty.',
                            },
                          ]}
                        >
                          <InputNumber max={9999} />
                        </Form.Item>
                      )}

                      {form.getFieldValue('collectionType') === 'Book' && (
                        <Form.Item label="Preview Link" name="previewLink">
                          <Input />
                        </Form.Item>
                      )}

                      <Form.Item wrapperCol={{ offset: 8, span: 16 }}>
                        <Button
                          type="primary"
                          htmlType="submit"
                          loading={isLoading}
                        >
                          Submit
                        </Button>
                      </Form.Item>
                    </Form>
                  </Col>
                  <Col span={12}></Col>
                </Row>
              </Spin>
            </div>
          </Content>
        </div>
      )}
    </div>
  );
};
